import { useAuthToken } from '@/hooks';
import { getDiscoveryProfileUrl } from '@/utils/discovery';

export interface InfluencerProps {
  influencerId?: string;
  jwt?: string;
}

export function Influencer({ influencerId: propInfluencerId, jwt: propJwt }: InfluencerProps) {
  const token = useAuthToken();
  const influencerId = propInfluencerId || '';
  const jwt = propJwt || token;

  if (!influencerId) return null;

  return (
    <iframe
      title="Creator profile"
      src={getDiscoveryProfileUrl(influencerId, jwt)}
      allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
      style={{ border: 'none', width: '100%', height: '100%' }}
    />
  );
}
